<template>
      <!-- 版权信息 -->
      <footer class="footer">
      <p>粤ICP备20016615号 - 深圳四为教育培训有限公司</p>
      <p>© 2019 - 2023, All rights reserved.</p>
      </footer>
</template>
  
  <script>
  export default {
    name: 'SiteFooter'
  }
  </script>
  
  <style scoped>
  /* 版权信息 */
  .footer {
    box-sizing: border-box;
    width: 100%;
    /* height: 76px; */
    text-align: center;
    padding-bottom: 39px;
    background-color: #f8f8f8;
    /* border: 1px solid blue; */

    flex: 0 0 auto; /* 不增长，不收缩，自动高度 */
    /* 或者指定具体高度，例如： */
    height: 76px; /* 根据实际需要调整 */
  }
  
  .footer p {
    margin: 0;
    font-family: PuHuiTi-Regular;
    font-weight: 400;
    font-size: 17px;
    color: #B0B0B0;
    line-height: 18px;
  }

  </style>